// Configuration for the AI-modification workflow (SOW Deliverable 4).
//
// The browser reaches the workflow ONLY through thecodeword-server, under
// /api/v1 (routes E1 to E13 of the gateway's modification.router.ts), so the
// live client uses the shared apiClient and its API_BASE_URL, like the order
// calls do. No path variable: the routes sit under four prefixes.
//
// Adapter selection. THREE modes, committed default 'off', compared with ===
// against the exact strings, the same discipline as api/pricing/config.ts. A
// wrong-cased or padded value is present, non-empty, and still off.
//
// 'off'  -> every call refuses, every way in is hidden, a direct visit says
//           the feature is not available.
// 'mock' -> explicit development opt-in: a local stand-in for the gateway.
// 'live' -> the real gateway routes.
//
// The deployed value goes in the CI env matrix, which this change does not
// touch: the exact line is in ops/ai-approval-build-2026-10-19/session3-frontend/for-igor.md.
export const MODIFICATION_MODE: 'off' | 'mock' | 'live' =
  process.env.REACT_APP_MODIFICATION_MODE === 'live'
    ? 'live'
    : process.env.REACT_APP_MODIFICATION_MODE === 'mock'
      ? 'mock'
      : 'off';

export const MODIFICATION_ENABLED = MODIFICATION_MODE !== 'off';

// How the upload screen waits for the server's background check after submit:
// it reads the record again, starting every 2 seconds and backing off to every
// 10, and stops waiting after 5 minutes (the check carries on server side; the
// result then shows on the modification page). Screen timing only, not policy.
export const MODIFICATION_POLL_START_MS = 2_000;
export const MODIFICATION_POLL_MAX_MS = 10_000;
export const MODIFICATION_POLL_GIVE_UP_MS = 5 * 60 * 1000;

// The filled addendum (E14) is asked for only once the buyer has stopped typing for this long, so a request is made
// per pause, not per keystroke. 2.5 s rather than 1 s so the short pauses of someone revising a long text do not each
// cost a request against the hourly limit (peer review, 23 Oct). Screen timing only, not policy.
export const MODIFICATION_AGREEMENT_WAIT_MS = 2_500;
